const WHATSAPP_ROUTER_URL =
  'https://dsxtxmljj8.execute-api.us-west-1.amazonaws.com/webhook';
export const SITE_ACCOUNT = 'morada';
const WHATSAPP_CHANNEL = SITE_ACCOUNT;

export function routedWhatsAppUrl(message: string = ''): string {
  const text = `${message || ''}`.trim();
  return `${WHATSAPP_ROUTER_URL}?action=whatsapp_redirect&channel=${WHATSAPP_CHANNEL}` +
    (text ? `&text=${encodeURIComponent(text)}` : '');
}
